import TabCell from "../TabCell";
import {GoingUtils} from "goingutils";

import {
    _initSplitBarEvent,
    _getAccountChange,
    _getSearchInput,
} from "../comJs";

class RelPersonTab extends TabCell {
    constructor(vueObj, goTabs) {
        super();
        this.tabId = GoingUtils.getUUid(10);
        this.tabIdName = "relPerson";
        this.tabLabel = "关联人员";
        this.active = false;
        this.hasSaveGroup = false;
        this.goTabs = goTabs;
    }

    getLeftCellContent() {
        return `<div class="filter-bar clearfix">
              <div class="tree-sel-drop pull-left">
                 ${_getAccountChange(360)}
              </div> 
            </div>
            <div class="filter-bar clearfix" style="padding-top: 0">
              <div class="tree-sel-drop pull-left">
                 ${_getAccountChange(175)}
              </div>
              <div class="search-input pull-left">  
                 ${_getSearchInput(175)}
              </div> 
            </div>
            <div class="depart-tree-div" style="height: 400px;"> 
               <div id="${this.tabId}_tree"></div>
            </div>
           `;
    }

    getRightCellContent(panelHeight) {
        let pabelHeight = panelHeight - 40 + "px";
        return `<div>
            <div class="filter-bar clearfix"> 
                 <div class="pull-left" style="height: 30px;line-height: 30px;cursor: pointer;">【保存为组】</div>
               <div class="search-input pull-right" style="margin-right: 10px;">  
                   ${_getSearchInput()}
                </div>
            </div>
             <div class="already-sel-user">
                  <div id="${
            this.tabId
            }_already_sel"  style="height: ${pabelHeight};"></div>
            </div>
         </div>`;
    }

    //初始化tabcell的容器控件
    initTabCellCtl() {
        //待选择数据的表格
        this.initAlreadyGrid();
        //设置缺少值
        this.initDefEvent({});
        this.initCtlEvent();
    }

    //初始化控件事件
    initCtlEvent() {
        var tabCellObj = this;
        //初始化分隔栏的事件
        _initSplitBarEvent(tabCellObj);
        this.initIconBtnEvent();
        //初始化账套树
        this.initAccountTree(function () {
        });
    }

    allCheckBoxClick() {
    }

    changeAccountEvent() {
    }

    destructionTab() {
    }

    removeSelectedRecord() {
    }
}

function initRelPersonTab(goTabs, vueObj) {
    let groupTab = new RelPersonTab(vueObj, goTabs);
    goTabs.addTabToFactory("relPerson", groupTab);
}

export default initRelPersonTab;



// WEBPACK FOOTER //
// ./goingsrc/jsCom/goAclDialog/components/relPersonTab.js